import React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import theme from '../../../style/theme';
import Button from '../Buttons/index';

const customStyles = {
  content: {
    maxWidth: '488px',
    width: '100%',
    bottom: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFF',
  },
  overlay: {
    zIndex: 10,
  },
};

const FormContent = styled.div`
  width: 80%;
  margin: 2rem 0 0 10%;
  @media (max-width: 500px) {
    width: 95%;
    margin: 2rem 0 0 2.5%;
  }
`;

const FormsLine = styled.div`
  height: 10%;
`;

const InputItem = styled.input`
  outline: none;
  border: 0;
  width: 100%;
  color: #495345;
  font-size: 14px;
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    opacity: 1;
  }
  ::-moz-placeholder { /* Firefox 19+ */
    opacity: 1;
  }
  :-ms-input-placeholder { /* IE 10+ */
    opacity: 1;
  }
  :-moz-placeholder { /* Firefox 18- */
    opacity: 1;
  }
`;

const BarItem = styled.p`
  background: black;
  opacity: 0.4;
  height: 2px;
  width: 100%;
`;

const BarStyle = styled.div`
  background: black;
  opacity: 0.1;
  height: 2px;
  width: 100%;
  margin: .6rem 0 .6rem 0;
`;

const ButtonOptions = styled.div`
  display: flex;
  width: 90%;
  max-height: 2.5rem;
  margin: 2rem 0 2rem 5%;
  justify-content: space-between;
`;

const renderHiddenItens = (hiddeniten, title) => (
  <div key={hiddeniten.name} style={{ display: 'none' }}>
    <InputItem
      type={hiddeniten.type}
      name={hiddeniten.name}
      defaultValue={title}
      id={hiddeniten.name}
    />
  </div>
);

const renderItens = iten => (
  <FormsLine key={iten.name}>
    <InputItem
      type={iten.type}
      name={iten.name}
      required="required"
      id={iten.name}
      placeholder={iten.name}
    />
    <BarItem />
  </FormsLine>
);

const SpanText = styled.p`
  color: #495345;
  font-size: 14px;
`;

export class Form extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    const title = this.props.titleForm;
    const textForm = this.props.text;
    const textButtonWhatsApp = this.props.textWhatsApp;
    const IOdates = this.props.IOEmail;
    const linkWhatsApp = this.props.linkWhatsApp;
    const itensForm = this.props.itens;
    const hiddenItensForm = this.props.hiddenItens;
    return (
      <div>
        <ReactModal
          isOpen={this.state.modalIsOpen}
          // onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Form Modal"
          ariaHideApp={false}
        >
          <FormContent>
            <Button
              buttonType="Whatsapp"
              isVisible
              textButton={textButtonWhatsApp}
              link={linkWhatsApp}
            />
            <BarStyle />
            <SpanText>{textForm}</SpanText>
            <form
              name="form"
              autoComplete="off"
              method="POST"
              action={IOdates}
            >
              <input type="hidden" name="_language" value="pt-BR" />
              {itensForm ? itensForm.map(iten => renderItens(iten)) : null}
              {hiddenItensForm ? hiddenItensForm.map(hiddeniten => renderHiddenItens(hiddeniten, title)) : null}
              <ButtonOptions>
                <Button
                  buttonType="Close"
                  isVisible
                  textButton="Close"
                  onClick={this.props.close}
                />
                <Button
                  buttonType="submit"
                  isVisible
                  textButton="Enviar"
                />
              </ButtonOptions>
            </form>
          </FormContent>
        </ReactModal>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/UI/Forms/index.jsx